module.exports = __webpack_public_path__ + "static/img/search-bg.208d3fa0.png";